import { createFileRoute } from '@tanstack/react-router'

import { HeadToHeadPage } from '~/features/football-history/history-pages'
import { headToHeadQueryOptions } from '~/features/football-history/query-options'
import {
  headToHeadRouteSearchSchema,
  headToHeadSearchSchema,
  parseHeadToHeadSearch,
} from '~/features/football-history/search-schema'
import { footballCoreLocale } from '~/lib/navigation/football-core'
import { parsePublicFootballRouteInput } from '~/lib/public-football-read'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/$locale/_public/teams/compare')({
  validateSearch: (search: unknown) => parsePublicFootballRouteInput(headToHeadRouteSearchSchema, search),
  beforeLoad: ({ params, search }) => {
    parseHeadToHeadSearch(search, footballCoreLocale(params.locale))
  },
  head: ({ params }) => seo({
    title: '球队交手历史 | BallPeek',
    description: '所选受支持范围内的描述性共同足球历史与已记录比较。',
    pathname: '/teams/compare',
    locale: params.locale,
  }),
  loader: async ({ context, location }) => {
    await context.queryClient.prefetchQuery(
      headToHeadQueryOptions(headToHeadSearchSchema.parse(location.search)),
    )
  },
  component: LocalizedHeadToHeadRoute,
})

function LocalizedHeadToHeadRoute() {
  return <HeadToHeadPage search={Route.useSearch()} />
}
